// extracted by mini-css-extract-plugin
export var process = "process-module--process--680a7";
export var process__button = "process-module--process__button--eac49";
export var process__container = "process-module--process__container--19285";
export var process__item = "process-module--process__item--cd4fc";
export var process__title = "process-module--process__title--7ac48";
export var process__wrapper_left = "process-module--process__wrapper_left--210f2";